import { DiagnosisCard } from './DiagnosisCard';
import type { Diagnosis } from '../../types/diagnosis';

interface HealthTimelineProps {
  diagnoses: Diagnosis[];
  plantId: string;
  loading?: boolean;
}

/**
 * Editorial Health Timeline — diagnosis history for a plant
 */
export function HealthTimeline({ diagnoses, plantId, loading = false }: HealthTimelineProps) {
  return (
    <div>
      <h3 className="section-header mb-4">Health Timeline</h3>

      {loading ? (
        <div className="flex items-center justify-center py-6" role="status" aria-live="polite">
          <span
            className="material-symbols-outlined text-primary animate-pulse"
            style={{ fontSize: 24 }}
            aria-hidden="true"
          >
            monitor_heart
          </span>
          <span className="sr-only">Loading diagnoses...</span>
        </div>
      ) : diagnoses.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="space-y-3" role="list" aria-label="Diagnosis history">
          {diagnoses.map((diagnosis) => (
            <div key={diagnosis.id} role="listitem">
              <DiagnosisCard diagnosis={diagnosis} plantId={plantId} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function EmptyState() {
  return (
    <div className="text-center py-8 border border-gray-200 rounded-lg bg-white">
      <span
        className="material-symbols-outlined text-gray-300 mb-3 block"
        style={{ fontSize: 32 }}
        aria-hidden="true"
      >
        favorite
      </span>
      <p className="font-display font-bold text-gray-400">No diagnoses yet</p>
      <p className="text-sm font-serif text-gray-400 mt-1">
        Tap &ldquo;Health Checkup&rdquo; to scan for issues
      </p>
    </div>
  );
}
